class MainCollection extends HTMLElement {
    constructor() {
        super();

        this.querySelectorAll('[data-id-2]').forEach((el) => {
            el.addEventListener('click', () => {
                this.toogleFacets(el);
            });
        });

        this.sortButtons = this.querySelectorAll("[data-sort-by]");

        this.querySelectorAll('.custom-sort').forEach((el) => {
            el.addEventListener('click', () => {
                this.toogleSort(el);
            });
        });

        this.querySelectorAll('.selection-grid .grid_selector').forEach((el) => {
            el.addEventListener('click', () => {
                this.changeGrid(el);
            });
        });

        this.querySelector('[data-open-facets]').addEventListener('click', () => {
            this.toggleFilters();
        });

        this.querySelectorAll('[data-close-drawer-filter]').forEach((el) => {
            el.addEventListener('click', this.toggleFilters.bind(this))
        })


        document.querySelector('.collection-linklist__list-select').onchange = function () {
            console.log('a[data-handle-custom="' + this.value + '"]');
            document.querySelector('a[data-handle-custom="' + this.value + '"]').click();
        };
    }

    changeGrid(el) {
        el.closest('.selection-grid').querySelectorAll('.grid_selector').forEach((elem) => {
            elem.classList.remove('active');
            document.querySelector('.product-grid-container').classList.remove(elem.dataset.class);
        });

        el.classList.add('active');
        document.querySelector('.product-grid-container').classList.add(el.dataset.class);
    }



    toggleFilters() {
        let filters = this.querySelector('.collection-filters__container');
        if (filters.classList.contains('open')) {
            filters.classList.remove('open');
            document.body.classList.remove('overflow-hidden-filters');
        } else {
            filters.classList.add('open');
            document.body.classList.add('overflow-hidden-filters');
        }
    }

    toogleSort(el) {
        let sort = el.getAttribute('data-sort');

        document.querySelectorAll('aside #SortBy option').forEach((el) => {
            el.selected = false;
        });

        if (el.querySelector('span').classList.contains('active')) {
            el.querySelector('span').classList.remove('active');
            document
                .querySelector("#FacetFiltersForm")
                .dispatchEvent(new Event("input"));
            return;
        } else {
            this.querySelectorAll('.custom-sort').forEach((el) => {
                el.querySelector('span').classList.remove('active');
            });

            el.querySelector('span').classList.toggle('active');

            document.querySelectorAll('aside #SortBy option').forEach((el) => {
                el.selected = false;
            });

            document.querySelector(`aside #SortBy [value='${sort}']`).selected = true;

            console.log(document.querySelector('#SortBy').value);

            document
                .querySelector("#FacetFiltersForm")
                .dispatchEvent(new Event("input"));
        }

    }


    toogleFacets(el) {
        console.log(el);
        let id = el.getAttribute('data-id-2');
        console.log(document.querySelector(`[for="${id}"]`));
        const facet = document.querySelector(`[for="${id}"]`);
        el.classList.toggle('active');
        facet.click();
    }
}

customElements.define('main-collection', MainCollection);